import isUndefined from 'lodash/fp/isUndefined';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { selectOrderedWaypoints } from '../../store/search/searchSelectors';
import { waypointsChanged } from '../../store/search/searchSlice';
import { mapItineraryIntoWaypoints } from './itineraryMapper';
import { selectCurrentTour, selectItinerary, selectTourHandlingItinerary } from '../../store/tour/tourSelectors';

export const updateItineraryWaypoints = (dispatch: RootDispatch, getState: () => RootState) => {
    const currentWaypoints = selectOrderedWaypoints(getState());
    // When editing from the tour handling flow the planning-flow itinerary is not yet
    // populated, so fall back to the tour handling itinerary as the seed.
    const itinerary = selectItinerary(getState()) ?? selectTourHandlingItinerary(getState());
    const tour = selectCurrentTour(getState());
    const initialCargoWeight = tour?.departure.initialCargoWeight;

    if (isUndefined(itinerary)) {
        throw new Error('Invalid itinerary');
    }

    const waypoints = mapItineraryIntoWaypoints(itinerary, currentWaypoints, initialCargoWeight, tour?.waypoints);
    dispatch(waypointsChanged({ waypoints }));
};
